import React, { Component } from 'react';
import { arrayOf, bool, number, shape, string } from 'prop-types';
import segmentStatusPropType from 'propTypes/segmentStatus';
import SegmentPath from 'components/Map/MapComponents/SegmentPath';
import RouteTooltip from 'components/Map/MapComponents/RouteTooltip';

export default class Segment extends Component {
  static propTypes = {
    isSelected: bool.isRequired,
    isActive: bool.isRequired,
    segment: shape({
      path: arrayOf(arrayOf(number)).isRequired,
      status: segmentStatusPropType.isRequired,
    }).isRequired,
    route: shape({
      from: shape({
        name: string,
      }).isRequired,
      to: shape({
        name: string,
      }).isRequired,
      status: segmentStatusPropType.isRequired,
      liveTravelTime: number.isRequired,
    }),
  };

  defaultProps = {
    priority: 0,
  };

  state = {
    travelTimeTrend: null,
  };

  componentWillReceiveProps(nextProps) {
    const trend = nextProps.route.liveTravelTime >= this.props.route.liveTravelTime ? 'up' : 'down';
    this.setState({ travelTimeTrend: trend });
  }

  render() {
    // eslint-disable-next-line global-require
    const { FeatureGroup } = require('react-leaflet');

    const { segment, isActive, route, isSelected } = this.props;
    const { path, status: segmentStatus } = segment;

    const { status: routeStatus, from, to, liveTravelTime, distance } = route;
    const name = { from: from.name, to: to.name };

    return (
      <FeatureGroup>
        <SegmentPath
          latLngList={path}
          status={isSelected ? segmentStatus : routeStatus}
          isActive={isActive}
        />
        <RouteTooltip
          status={routeStatus}
          name={name}
          liveTravelTime={liveTravelTime}
          travelTimeTrend={this.state.travelTimeTrend}
          distance={distance}
        />
      </FeatureGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/RouteSegment/index.js